import { render, staticRenderFns } from "./content.vue?vue&type=template&id=4dfd6c5e&scoped=true"
import script from "./content.vue?vue&type=script&lang=js"
export * from "./content.vue?vue&type=script&lang=js"
import style0 from "./content.vue?vue&type=style&index=0&id=4dfd6c5e&prod&scoped=true&lang=css"
import style1 from "./content.vue?vue&type=style&index=1&id=4dfd6c5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd6c5e",
  null
  
)

export default component.exports